import { Batch } from 'js/constants/types/batch';
import UtilsServices from 'js/tools/utils-services';
import { useStore } from 'store';

/*
 *  Shared variables and methods
 */
const token = useStore.getState().user?.token;
const headers = new Headers({ Authorization: `Bearer ${token}`, 'content-type': 'application/json' });
const baseUrl = process.env.REACT_APP_API_ENDPOINT;

useStore.subscribe((state) => {
    headers.set('Authorization', `Bearer ${state.user?.token}`);
});

/*
 *  Services
 */
export default class BatchServices {
    public static getBatches = async (): Promise<Batch[]> => {
        const response = await fetch(`${baseUrl}/API/Batches/Batches`, { headers });
        const data = await UtilsServices.processResponse(response);

        return data;
    };
}
